import mortgageService from "../../services/mortgage";
import { config } from "../../config.js";
const utmSource = config.source[process.env.VUE_APP_BRAND];

export const mortgageAffordModule = {
  namespaced: true,
  state: {
    proposals: null,
    recommendedValues: null,
    errors: null,
  },
  mutations: {
    SET_PROPOSALS: (state, proposals) => {
      state.proposals = proposals;
    },
    CLEAR_ALL: (state) => {
      state.proposals = null;
    },
    SET_RECOMMENDED_VALUES: (state, values) => {
      state.recommendedValues = values;
    },
    SET_ERRORS: (state, errors) => {
      state.errors = errors;
    },
  },
  getters: {
    all: (state) => {
      return state;
    },
    proposals: (state) => {
      return state.proposals;
    },
    recommendedValues: (state) => {
      return state.recommendedValues;
    },
    errors: (state) => {
      return state.errors;
    },
    fixedProposal: (state) => {
      return state.proposals.F
        ? {
            mortgage_condition: state.proposals.F.mortgageCondition.id,
            amount_borrowed: state.proposals.F.amountBorrowed,
            price: state.proposals.F.propertyPrice,
            years: state.proposals.F.years,
            interest_type: state.proposals.F.mortgageCondition.interest_type,
          }
        : null;
    },
    variableProposal: (state) => {
      return state.proposals.V
        ? {
            mortgage_condition: state.proposals.V.mortgageCondition.id,
            amount_borrowed: state.proposals.V.amountBorrowed,
            price: state.proposals.V.propertyPrice,
            years: state.proposals.V.years,
            interest_type: state.proposals.V.mortgageCondition.interest_type,
          }
        : null;
    },
    bestProposal: (state, getters) => {
      return getters.fixedProposal
        ? getters.fixedProposal
        : getters.variableProposal;
    },
    hasProposal: (state, getters) => {
      return getters.fixedProposal || getters.variableProposal;
    },
  },
  actions: {
    clearAll(ctx) {
      ctx.commit("CLEAR_ALL");
    },
    async requestMortgage({ commit, state, rootState, getters }) {
      const data = {
        client: {
          name: rootState.personalData.name,
          surname: rootState.personalData.surname,
          email: rootState.personalData.email,
          phone: rootState.personalData.phone,
          utm_source: utmSource,
          utm_medium: "web",
          utm_campaign: "listing",
        },
        mortgage: {
          price: state.proposals.F
            ? state.proposals.F.propertyPrice
            : state.proposals.V.propertyPrice,
          income: rootState.affordData.income,
          savings: rootState.affordData.savings,
          province_id: rootState.affordData.province_id,
        },
        proposal: getters.bestProposal,
      };
      commit("ui/SET_LOADING", true, { root: true });
      try {
        await mortgageService.requestMortgage(
          getters.bestProposal.mortgage_condition,
          data
        );
      } catch (error) {
        return {};
      } finally {
        commit("ui/SET_LOADING", false, { root: true });
        commit("ui/SET_STEP", 4, { root: true });
      }
    },
    async updateAfford({ commit, rootGetters }) {
      commit("ui/SET_LOADING", true, { root: true });
      const response = await mortgageService.submitAffordMortgage(
        rootGetters["affordData/all"]
      );
      commit("ui/SET_LOADING", false, { root: true });
      commit("ui/SET_STEP", 2, { root: true });
      commit("SET_PROPOSALS", response);
      commit("ui/SET_RESULTS", false, { root: true });
    },
  },
};
